import { render, staticRenderFns } from "./BarcodeManufacturerSelect.vue?vue&type=template&id=d8834896"
import script from "./BarcodeManufacturerSelect.vue?vue&type=script&lang=ts"
export * from "./BarcodeManufacturerSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports